import React, { useEffect, useState, useContext } from 'react';
import Client from '../../api/client';
import UserContext from '../../business/referential/UserContext';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import CopyrightWebResponse from '../../components/response/CopyrightWebResponse';
import ProgressStepsWeb from '../../components/effects/ProgressStepsWeb';
import Modal from 'react-bootstrap/Modal';
import parse from "html-react-parser";

function CopyrightWeb({ currentRefresh, setRefresh }) {
    const [sectors, setSectors] = useState(null);
    const [title, setTitle] = useState(null);
    const [description, setDescription] = useState(null);
    const [websiteUrl, setWebsiteUrl] = useState(null);
    const [linkList, setLinks] = useState(null);
    const [ids, setSectorId] = useState(1);
    const [userData, setUserData] = useState(null);
    const [callback, setCallback] = useState(null);
    const [stepsDone, setComplete] = useState(null);
    const ctx = useContext(UserContext);
    const [show, setShow] = useState(false);
    const [pageId, setPageId] = useState(17);

    const getContent = (key) => {
        if (userData) {
            if (userData.dataContent[pageId][key]) {
                return userData.dataContent[pageId][key].contentTxt;
            }
        }
        return '';
    }

    useEffect(() => {
        if (stepsDone) {
            setTimeout(() => setShow(false), 500);
        }
    }, [stepsDone]);

    useEffect(() => {

        const process = async () => {
            await Client.getSectors().then(result => {
                if (result) {
                    setSectors(JSON.parse(result));
                }
            });

            Promise.resolve(ctx).then(value => {
                setUserData(value);
            });
        }

        process();
    }, []);

    const isValidURL = (string) => {
        var res = string.match(/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi);
        return (res !== null);
    };

    const handleSubmit = (evt) => {
        evt.preventDefault();
        processSubmit();
    }

    const handleSectorId = (id) => {
        setSectorId(id);
    }

    const handleWebsiteUrl = (url) => {
        if (isValidURL(url))
            setWebsiteUrl(url);
    }

    const handleUrls = (urls) => {
        if (urls) {
            let output = [];
            let links = urls.split(/\n/)
            if (links && links.length > 0) {
                for (let i = 0; i < links.length; i++) {
                    if (isValidURL(links[i]))
                        output.push(links[i]);
                }
            }

            if (output.length > 0) {
                setLinks(output);
            }
        }
    }

    const processSubmit = () => {
        const update = async () => {
            //DO SUBMIT
            if (linkList && linkList.length > 0 && websiteUrl) {
                let idc = userData.userObject.id;
                let idSector = ids;
                setShow(true);
                await Client.doCopyrightWeb(idc, idSector, title, description, websiteUrl, linkList).then(data => {
                    if (data.data) {
                        if (data.data.statusCode && data.data.statusCode === 500) {
                            NotificationManager.error(getContent("CW_ERRORMESSAGE"));
                            setShow(false);
                            return;
                        }
                        setCallback(data.data);
                        setTimeout(() => setRefresh(currentRefresh + 1), 15000);
                    }
                    else {
                        NotificationManager.error(getContent("CW_ERRORMESSAGE"));
                        setShow(false);
                    }
                });
            }
        }
        update();
    }


    return (
        <>
            {(callback === null || stepsDone === null) &&
                <div className="dashboard-container">
                    <h3 className="mb-2">
                        {getContent("RegisterWebsiteTitle")}
                    </h3>
                    <p className="md-4 mb-xl-5">{getContent("RegisterWebsiteSubtitle")}</p>
                    {userData &&
                        <form className="dashboard-form" onSubmit={handleSubmit}>
                            {sectors &&
                                <select required className="form-select mb-3" onChange={(v) => handleSectorId(v.target.value)}>
                                    {sectors.map((value, index) => <option key={index} value={value.idField}>{value.valueField}</option>)}
                                </select>}
                            <div className="mb-3">
                                <label className="form-label">
                                    <input type="text" className="form-control" placeholder={getContent("Step4")} onChange={(v) => setTitle(v.target.value)} required />
                                </label>
                            </div>
                            <div className="mb-3">
                                <label className="form-label">
                                    <textarea className="form-control" rows="5"
                                        placeholder={getContent("Step5")} onChange={(v) => setDescription(v.target.value)} required></textarea>
                                </label>
                            </div>
                            <div className="mb-3">
                                <label className="form-label">
                                    <input type="text" className="form-control"
                                        placeholder={getContent("Step2")} onChange={(v) => handleWebsiteUrl(v.target.value)} required />
                                </label>
                            </div>
                            <div className="mb-4">
                                <label className="form-label">
                                    <textarea className="form-control" rows="5"
                                        placeholder={getContent("Step3")} onChange={(v) => handleUrls(v.target.value)} required></textarea>
                                </label>
                            </div>
                            <button className="btn btn-blue mb-4">
                                {getContent("BtnRegister")}
                            </button>
                        </form>}
                    <p className="note">
                        {getContent("CW_NOTE")}
                    </p>
                    <h6>
                        {getContent("LblTextBottom2")}
                    </h6>
                    <a href="/dashboard" className="arrow-back"></a>
                </div>}
            {callback && stepsDone &&
                <CopyrightWebResponse Callback={callback} />
            }
            <Modal show={show} size="lg" aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">{getContent("CW_PLEASEWAIT")}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ minHeight: '210px' }}>
                    <ProgressStepsWeb show={show} done={callback} setComplete={setComplete} />
                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </Modal>
            <NotificationContainer />
        </>
    );
}

export default CopyrightWeb;